import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAuth = true }) => {
    const { isAuthenticated, loading, emailVerificationRequired } = useAuth();
    const location = useLocation();

    // Show loading spinner while checking authentication
    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50">
                <div className="flex flex-col items-center space-y-4">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
                    <p className="text-gray-600 text-sm">Loading...</p>
                </div>
            </div>
        );
    }

    // If route requires authentication and user is not authenticated
    if (requireAuth && !isAuthenticated) {
        // Redirect to login page with return url
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If user is authenticated but needs email verification
    if (requireAuth && isAuthenticated && emailVerificationRequired) {
        // Allow access to dashboard (which will handle verification)
        // but redirect other protected routes to dashboard for verification
        if (location.pathname !== '/dashboard' && location.pathname !== '/profile-dashboard') {
            return <Navigate to="/dashboard" replace />;
        }
    }

    // If route is for unauthenticated users only (like login/register) and user is authenticated
    if (!requireAuth && isAuthenticated && !emailVerificationRequired) {
        // Redirect to dashboard or intended page
        const from = location.state?.from?.pathname || '/dashboard';
        return <Navigate to={from} replace />;
    }

    // User has correct authentication status for this route
    return children;
};

export default ProtectedRoute; 